// const initialLanguages = ['en', 'de', 'ru'];

const initialLanguages = [
    {
        code: 'en',
        name: 'English',
    },
    {
        code: 'ru',
        name: 'Russian',
    },
    // {
    //   code: 'de',
    //   name: 'German',
    // },
    {
        code: 'es',
        name: 'Spanish',
    },
]

const languagePickerReducer = (languages, action) => {
    const { type, payload } = action

    switch (type) {
        case 'CHANGE_LANGUAGE': {
            languages.splice(languages.indexOf(payload), 1)
            languages.unshift(payload)
            return languages
        }
        default:
            return languages
    }
}

export { initialLanguages, languagePickerReducer }
